import { render } from "./Examinationtime.vue?vue&type=template&id=48e5b833&scoped=true"
import script from "./Examinationtime.vue?vue&type=script&lang=js"
export * from "./Examinationtime.vue?vue&type=script&lang=js"

import "./Examinationtime.vue?vue&type=style&index=0&id=48e5b833&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e5b833"]])

export default __exports__